import { MODELS, useMultiModel } from "../../../api";
import { Toolbar } from "../../../design-system/components/Toolbar/Toolbar.jsx";
import { Roles } from "../../../lib/Roles.jsx";
import { ROUTES } from "../../../routes.js";
import { ClassroomManagementButton } from "../classroom-management/ClassroomManagementButton";
import { useSparkContext } from "../context/SparkContext.jsx";
import styles from "./toolbarContainer.css.ts";

export function ToolbarContainer() {
  const { workshop, spark, settings } = useSparkContext();
  // If the user is a student in this workshop, get their small team.
  // This checks the global role of the user, not the local role.
  // If a teacher account is a student in a Lernreise, this will lead to issues.
  // But the system does not currently support roles-by-lernreise anyway.
  const [smallTeam] = useMultiModel([
    workshop.roles?.includes(Roles.STUDENT)
      ? MODELS.SMALL_TEAM({ workshopId: workshop.id })
      : null,
  ]);

  const baseUrl = ROUTES.spark.getUrl({
    workshopSlug: workshop.slug,
    sparkSlug: spark.slug,
  });
  const leaveTo = ROUTES.lernreisenOverview.getUrl();

  // Select the highest role the user has in this workshop.
  let userRole = Roles.STUDENT;
  if (workshop.roles?.includes(Roles.TEACHER)) userRole = Roles.TEACHER;
  if (workshop.roles?.includes(Roles.ADMIN)) userRole = Roles.ADMIN;

  return (
    <div className={styles.toolbarContainer}>
      <Toolbar
        smallTeam={smallTeam}
        showLibraryButton={settings?.libraryEnabled}
        showUploadButton={userRole === Roles.STUDENT}
        showLernreiseAdminButtons={userRole !== Roles.STUDENT}
        showGlossaryButton={spark.showGlossary}
        classroomButton={
          spark.classroomManagementEnabled ? (
            <ClassroomManagementButton workshopId={workshop.id} />
          ) : null
        }
        baseUrl={baseUrl}
        leaveTo={leaveTo}
      />
    </div>
  );
}
